import { createSlice } from '@reduxjs/toolkit';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from 'store';

export type Profile = {
  nickname: string;
  gender: 0 | 1 | 2 | 3;
  ageGroup: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  occupation: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  residence: string;
  visitPurpose: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 99;
};

export type ErrorResponse = {
  message: string;
};

export type ProfileAPIResponse = {
  '200': Profile;
  '400': ErrorResponse;
  '401': ErrorResponse;
  '500': ErrorResponse;
};

const baseUrl = process.env.REACT_APP_API_ENDPOINT || '';

export const profileAPI = createApi({
  reducerPath: 'profileAPI',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      // ここにカスタムヘッダーを追加します
      // 現在の状態にアクセスします
      const state = getState() as RootState;
      // 状態からユーザートークンを取得します
      const userToken = state.liffUser.userToken; // cspell:disable-line
      headers.set('Content-Type', 'application/json');
      headers.set('Authorization', `Bearer ${userToken}`);
      return headers;
    },
  }),
  tagTypes: ['Profile'],
  endpoints: builder => ({
    getProfile: builder.query<Profile, void>({
      query: () => ({
        url: `/profile`,
        method: 'GET',
      }),
    }),
    putProfile: builder.mutation<Profile, Partial<Profile>>({
      query: profile => ({
        url: `/profile`,
        method: 'PUT',
        body: profile,
      }),
    }),
  }),
});

export const { useGetProfileQuery, usePutProfileMutation } = profileAPI;

export const profileSlice = createSlice({
  name: 'profile',
  initialState: {} as Profile,
  reducers: {},
  extraReducers: builder => {
    builder.addMatcher(profileAPI.endpoints.getProfile.matchFulfilled, (_state, action) => {
      return action.payload;
    });
    builder.addMatcher(profileAPI.endpoints.putProfile.matchFulfilled, (_state, action) => {
      return action.payload;
    });
  },
});

export default profileSlice.reducer;
